<template>
  <div>
    <Nav />
    <Kv />
    <Beauty3d />
    <Component21 />
  </div>
</template>
<script>
import Nav from '@/v2/auto/sections/0-top_nav.vue'
import Kv from '@/v2/auto/sections/1-top_kv.vue'
import Beauty3d from '@/v2/auto/sections/20-beauty_3d.vue'
import Component21 from '@/v2/auto/sections/21-beauty_3d.vue'
export default {
  components: {
    Nav,
    Kv,
    Beauty3d,
    Component21,
  },
}
</script>
